export default class SignUpController {
    /* @ngInject */
    constructor($ionicPopup, $ionicLoading, $scope, $state, ApiUser, digiCert, $location) {
        this.$ionicPopup = $ionicPopup;
        this.$ionicLoading = $ionicLoading;
        this.$scope = $scope;
        this.$state = $state;
        this.ApiUser = ApiUser;
        this.user = {};
        this.digiCert = digiCert;
        this.$location = $location;
    }

    init(signUpForm) {
        this.signUpForm = signUpForm;
        this.setPristine();
        this.digiCert.loadCertificate();
        this.user.email = this.$location.search().email;
        this.isTokenRedirection = !!this.$location.search().email;
    }

    setPristine() {
        this.user = {};
        this.signUpForm.$setPristine();
    }

    showLoading() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
    }

    hideLoading() {
        this.$ionicLoading.hide();
    }

    signUp() {
        this.showLoading();

        var userData = {};
        userData.firstName = this.user.firstName;
        userData.name = this.user.name;
        userData.email = this.user.email;
        userData.password = this.user.password;
        userData.company = this.user.company;
        userData.groupInvitationToken = this.$location.search().token || '';
        this.ApiUser.signUpUser(userData).then((res) => {
            this.hideLoading();

            if (res !== undefined) {
                var alertPopup = this.$ionicPopup.alert({
                    title: 'Check email',
                    template: 'In order to complete your registration, please click the confirmation link in the email that we have sent to you.'
                });

                alertPopup.then((res) => {
                    this.setPristine();
                    this.$state.go('login');
                });
            }
        });
    }

}



/** WEBPACK FOOTER **
 ** ./src/app/components/user/signUp.controller.js
 **/